module.exports = __webpack_public_path__ + "img/уральская деревня 60х90.d071196f.jpg";